/* ============
 * Create Page
 * ============
 *
 * This is the page for adding subscribe.
 */
import { mapGetters } from 'vuex';
import subscriberService from './../../../../services/subscriberList';
import subscriberListTransformer from './../../../../transformers/subscriberList';
import publicProfileService from './../../../../services/publicProfile';
import Forms from './../../../../utils/forms/forms';

export default {
  data() {
    return {
      form: new Forms({
        name: {
          value: '',
          type: 'text',
        },
        selectDefaultEmail: {
          value: 'true',
          type: 'checkbox',
        },
        fromEmail: {
          value: '',
          type: 'email',
        },
        selectDefaultName: {
          value: 'true',
          type: 'checkbox',
        },
        fromName: {
          value: '',
          type: 'text',
        },
        description: {
          value: '',
          type: 'textarea',
        },
        doubleOptinRequired: {
          value: 1,
          type: 'switch',
        },
        optinEmailSubject: {
          value: '',
          type: 'text',
        },
        optinEmailBody: {
          value: '',
          type: 'textarea',
        },
      }),
      defaultName: '',
      defaultEmail: '',
      loading: false,
      optinEmailSubjectHolder: '',
      optinEmailBodyHolder: '',
    };
  },

  computed: {
    ...mapGetters({
      // 
    }),
  },

  watch: {
    
    /**
     * Watch selectDefaultName checkbox.
     *
     * @param  {Boolean} value Checked or not.
     */
    'form.selectDefaultName': function (value) {
      if (value) {
        this.form.disableField('fromName');
        this.form.setFieldValue('fromName', this.defaultName);
      } else { 
        this.form.enableField('fromName');
        this.form.setFieldValue('fromName', '');
      }
    },

    /**
     * Watch selectDefaultName checkbox.
     *
     * @param  {Boolean} value Checked or not.
     */
    'form.selectDefaultEmail': function (value) {
      if (value) {
        this.form.disableField('fromEmail');
        this.form.setFieldValue('fromEmail', this.defaultEmail);
      } else { 
        this.form.enableField('fromEmail');
        this.form.setFieldValue('fromEmail', '');
      }
    },

    /**
     * Watch double optin switch.
     *
     * @param  {Boolean} value Checked or not.
     */
    'form.doubleOptinRequired': function (value) {
      if (value) {
        this.addRemoveFields(true);
      } else { 
        this.addRemoveFields(false);
      }
    },
  },

  created() {
    this.getOrgEmailName();
  },

  methods: {
    /**
     * Get org email and name
     */
    getOrgEmailName() {
      publicProfileService.show().then((data) => {
        this.defaultName = data.orgName;
        this.defaultEmail = data.orgEmail;

        this.form.setFieldValue('fromName', this.defaultName);
        this.form.setFieldValue('fromEmail', this.defaultEmail);
        this.form.disableField('fromName');
        this.form.disableField('fromEmail');

        this.optinEmailSubjectHolder = data.optinEmailSubject;
        this.optinEmailBodyHolder = data.optinEmailBody;
        this.form.setFieldValue('optinEmailSubject', this.optinEmailSubjectHolder);
        this.form.setFieldValue('optinEmailBody', this.optinEmailBodyHolder);
      }).catch((err) => {
        console.log('the error');
        console.log(err);
      });
    },

    /**
     * Dynamically add new fields
     */
    addRemoveFields(status) {
      if (status === true) {
        this.form.setFieldValue('optinEmailSubject', this.optinEmailSubjectHolder);
        this.form.setFieldValue('optinEmailBody', this.optinEmailBodyHolder);
        this.form.showField('optinEmailSubject');
        this.form.showField('optinEmailBody');
      } else {
        this.form.hideField('optinEmailSubject');
        this.form.hideField('optinEmailBody');
      }
    },


    /**
     * Method to store the subscriberList.
     */
    store() {
      this.form.loading = true;
      const subscriberList = subscriberListTransformer.send(this.form.data());
      subscriberService.store(subscriberList).then(() => {
        this.form.loading = false;
        this.$message({
          message: 'Create successfully',
          type: 'success',
        });
      }).catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
      });
    },
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/subscriberList/create/create.js